"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomCity = exports.randomCoord = exports.randomZoomOut = exports.randomZoomIn = exports.randomZoom = exports.randomLng = exports.randomLat = exports.rand = void 0;
var cities_1 = require("./cities");
var rand = function (from, to, fixed) {
    if (fixed === void 0) { fixed = 0; }
    return parseFloat((Math.random() * (to - from) + from).toFixed(fixed));
};
exports.rand = rand;
var randomLat = function () { return exports.rand(-90, 90, 6); };
exports.randomLat = randomLat;
var randomLng = function () { return exports.rand(-180, 180, 6); };
exports.randomLng = randomLng;
var randomZoom = function () { return exports.rand(2, 15); };
exports.randomZoom = randomZoom;
var randomZoomIn = function () { return exports.rand(18, 18); };
exports.randomZoomIn = randomZoomIn;
var randomZoomOut = function () { return exports.rand(6, 6); };
exports.randomZoomOut = randomZoomOut;
var randomCoord = function () { return ({
    lat: exports.randomLat(),
    lng: exports.randomLng(),
}); };
exports.randomCoord = randomCoord;
var randomCity = function () {
    return cities_1.CITIES[Math.floor(Math.random() * cities_1.CITIES.length)];
};
exports.randomCity = randomCity;
